
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[lang]",
      function () {
        return require("private-next-pages/home/[lang].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/[lang]"])
      });
    }
  